export default "__VITE_ASSET__CPpp19V4__"